import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AddImage from '../../../../../../../../../admin/ImageManager/Add';
import { insertIntoEditor } from
  '../../../../../../../../../admin/SlideShow/Slide/Content/SlideObjectText/CustomFroalaCommands/FroalaListeners';

const CustomImageModal = ({ editorInstance, questionId, modalManager, isAdmin }) => {
  useEffect(() => {
  });

  const imageTag = imageModel => (
    <img
      alt={imageModel.image.descriptionEn ? imageModel.image.descriptionEn : ''}
      className="imageInQuestion"
      data-snippet={imageModel.snippet}
      src={imageModel.image.imageUrl}
    />
  );

  const afterSubmit = (res) => {
    const imageModel = res.length > 0 ? res[0] : res;
    insertIntoEditor(editorInstance, imageTag(imageModel));
  };

  return (
    <AddImage
      forFroala
      afterMergeDuplicates={afterSubmit}
      afterSubmit={afterSubmit}
      dontMergeCallback={afterSubmit}
      isAdmin={isAdmin}
      mediaMeta={{ type: 'answer' }}
      modalManager={modalManager}
      modelId={questionId}
      modelType="Question"
      standaloneButton={false}
    />
  );
};

CustomImageModal.propTypes = {
  editorInstance: PropTypes.object,
  isAdmin: PropTypes.bool,
  modalManager: PropTypes.shape({
    close: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    open: PropTypes.func.isRequired
  }).isRequired,
  questionId: PropTypes.number.isRequired,
};

CustomImageModal.defaultProps = {
  editorInstance: {},
  isAdmin: false,
};

export default CustomImageModal;
